<script>
  export let user;
  export let size = 'normal';
  export let showBorder = false;
  export let width;
  export let height;
  export let src;
  export let href;

  let sizeClass = size === 'small' ? 'small' : size === 'large' ? 'large' : 'normal';
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .avatar {
    display: inline-block;
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    background: #f5f3fc;

    &.small {
      width: 32px;
      height: 32px;
    }

    &.normal {
      width: 48px;
      height: 48px;
    }

    &.large {
      width: 64px;
      height: 64px;
    }

    &.with-border {
      border: 2px solid #fff;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .default {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f3fc;
      color: #896bd9;
      font-weight: 600;

      &.small {
        font-size: 14px;
      }

      &.normal {
        font-size: 18px;
      }

      &.large {
        font-size: 24px;
      }
    }
  }
</style>

{#if href}
  <a {href}>
    <div class="avatar {sizeClass}" class:with-border={showBorder} style={width ? `width: ${width}px; height: ${height || width}px;` : ''}>
      {#if src || user?.avatar_url}
        <img src={src || user.avatar_url} alt={user?.name || ''} />
      {:else}
        <div class="default {sizeClass}">{user?.name?.[0]?.toUpperCase() || '?'}</div>
      {/if}
    </div>
  </a>
{:else}
  <div class="avatar {sizeClass}" class:with-border={showBorder} style={width ? `width: ${width}px; height: ${height || width}px;` : ''}>
    {#if src || user?.avatar_url}
      <img src={src || user.avatar_url} alt={user?.name || ''} />
    {:else}
      <div class="default {sizeClass}">{user?.name?.[0]?.toUpperCase() || '?'}</div>
    {/if}
  </div>
{/if} 